'use strict';
/**
 * Demandes apprenants module
 */
angular.module('demandes-apprenants', ['demandes-apprenants.components']);

angular.module('demandes-apprenants.components', []);
